import { createFileRoute } from "@tanstack/react-router";
import UsSportsPredictions from "@/pages/UsSportsPredictions";
import { MainLayout } from "@/components/layout/MainLayout";
import { socialMeta, readable } from "@/lib/routeSocial";
import { findUsSport, findUsSportMarket } from "@/lib/oddsSports";

export const Route = createFileRoute("/{$sport}-predictions/$market")({
  head: ({ params }) => {
    const sport = findUsSport(params.sport);
    const market = sport ? findUsSportMarket(sport, params.market) : undefined;
    return {
      meta: socialMeta({
        seo: { topics: [params.market, params.sport, "predictions"] },
        ...((market?.keywords ?? sport?.keywords) ? { keywords: (market?.keywords ?? sport?.keywords)! } : {}),
        title:
          market?.title ??
          sport?.title ??
          `${readable(params.sport)} ${readable(params.market)} Predictions | Statlign`,
        description:
          market?.description ??
          sport?.description ??
          "Model predictions, odds and value edges with the reasoning shown for every pick.",
        ...(sport ? { image: `https://statlign.com/og-${sport.slug}.jpg` } : {}),
      }),
    };
  },
  component: () => (
    <MainLayout>
      <UsSportsPredictions />
    </MainLayout>
  ),
});
